/**
 * Тексти сервісу повідомлень і очікування (UX-13, UX-32; states.md). Не входить у зведений
 * `uk.ts`: його тягне документ входу, а там цих станів немає (бюджет входу). Тексти порожніх
 * станів — `uk/empty.ts`: вони потрібні лише лінивим екранам.
 */
/** «12 с» / «2 хв»: скільки чекати до повтору (UX-19). */
const after = (seconds: number) =>
  seconds < 60 ? `${Math.max(1, seconds)} с` : `${Math.ceil(seconds / 60)} хв`;

/** Чому відмовили: ліміт дій людини (SEC-134) чи перевантаження сервера. */
const busyWhy = (code: string) =>
  code === 'rate_limited' || code === 'too_many_requests'
    ? 'Забагато дій за короткий час.'
    : 'Сервер зайнятий.';

export const states = {
  notifyRegion: 'Повідомлення',
  /** Підказка клавіші в доступній назві зони тостів (UX-13: перейти — F8). */
  notifyRegionKeys: 'F8',
  loading: 'Завантаження…',
  loadingSlow: 'Довше, ніж зазвичай…',
  timeoutTitle: 'Сервер відповідає надто довго',
  timeoutText: 'Спробуйте ще раз. Якщо не допоможе — перевірте зв’язок.',
  busyWhy,
  /** Таймер автоматичного повтору зміни (видимий; програма читання чує лише початок). */
  busyRetrying: (seconds: number) =>
    seconds > 0 ? `Повторюємо через ${after(seconds)}…` : 'Повторюємо…',
  /** Повтор не допоміг або чекати задовго: людина повторює сама, введене на місці. */
  busyLater: (code: string, seconds: number) =>
    `${busyWhy(code)} Спробуйте ще раз через ${after(seconds)}.`,
  /** Оптимістична зміна офлайн не робиться (UX-17, UX-29). */
  changeOffline: 'Немає зв’язку — зміну не збережено. Повторіть, коли зв’язок повернеться.',
  changeFailed: 'Не вдалося зберегти',
  changeFailedNetwork: 'немає зв’язку з сервером',
  changeFailedForbidden: 'недостатньо прав',
  changeAgain: 'Ще раз',
} as const;
